package ru.chm.gradereport.ui.screens.publicstudent

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ru.chm.gradereport.data.GradeApi
import ru.chm.gradereport.model.HomeworkScoreItem
import ru.chm.gradereport.model.StudentStatsDto
import ru.chm.gradereport.ui.components.AppCard
import ru.chm.gradereport.ui.components.ErrorStateCard
import ru.chm.gradereport.ui.components.LoadingBox
import ru.chm.gradereport.ui.components.ScreenHeader
import ru.chm.gradereport.ui.components.ScreenScaffold
import ru.chm.gradereport.ui.screens.course.StudentStatsContent
import ru.chm.gradereport.ui.screens.course.sheet.HomeworkDetailsDialog
import ru.chm.gradereport.ui.screens.course.toHomeworkDto
import ru.chm.gradereport.ui.screens.course.toSessionOrNull

@Composable
fun StudentPublicScreen(
    api: GradeApi,
    publicToken: String,
    studentUid: String,
) {
    var stats by remember { mutableStateOf<StudentStatsDto?>(null) }
    var loading by remember { mutableStateOf(true) }
    var error by remember { mutableStateOf<String?>(null) }
    var viewingHomework by remember { mutableStateOf<HomeworkScoreItem?>(null) }

    LaunchedEffect(publicToken, studentUid) {
        loading = true
        error = null
        try {
            stats = api.publicStudentStatsByUid(publicToken, studentUid)
        } catch (e: Exception) {
            error = e.message ?: "Страница студента не найдена"
            stats = null
        } finally {
            loading = false
        }
    }

    ScreenScaffold {
        val current = stats
        ScreenHeader(
            title = current?.student?.fullName ?: "Статистика студента",
            subtitle = when {
                current == null && error != null -> "Не удалось открыть страницу"
                current == null -> "Публичная страница"
                else -> "${current.courseName} · UID ${current.student.uid}"
            },
        )

        when {
            loading -> LoadingBox()
            current != null -> AppCard(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = 4.dp),
            ) {
                StudentStatsContent(
                    stats = current,
                    onOpenHomework = { viewingHomework = it },
                )
            }
            error != null -> ErrorStateCard(
                title = "Страница недоступна",
                message = error!!,
                hint = "Проверьте публичную ссылку и UID студента. Если ссылка старая — откройте новую из карточки курса.",
                modifier = Modifier.padding(top = 4.dp),
            )
        }
    }

    viewingHomework?.let { item ->
        val courseId = stats?.student?.courseId.orEmpty()
        val session = item.toSessionOrNull(courseId)
        HomeworkDetailsDialog(
            homework = item.toHomeworkDto(courseId),
            sessions = listOfNotNull(session),
            session = session,
            editable = false,
            onDismiss = { viewingHomework = null },
            onSave = { _, _, _, _ -> },
            onDelete = {},
        )
    }
}
